import React from 'react';
import PropTypes from 'prop-types';

import FormManager from 'src/core/gd-form/common/form-manager';
import SelectUser from 'core/gd-ui/select-user/select-user';

import CustomFieldAddFormProto from "../../add-form-proto";
import CustomFieldLeftPanel from "../../common/panel/form-left-panel";
import CustomFieldPreview from "../../common/form-preview";
import CustomFieldRightPanel from "core/fields/custom/common/panel/form-right-panel";

export default class UserCustomFieldForm extends CustomFieldAddFormProto {

    static propTypes = {
        customField: PropTypes.object,

        onSubmit: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.type = gd.const.customFields.type.USER;

        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit(result) {
        result.name = result.name.trim();
        result.type = gd.const.customFields.type.USER;

        result.params = {
            scope: result.scope
        };

        this.props.onSubmit(result);
    }

    render() {
        const options = gd.session.companyUsers.filterByCompany(this.props.organizationId).map(cu=>cu.user.id);

        return (
            <React.Fragment>
                <CustomFieldLeftPanel parent={this}>
                    <CustomFieldPreview noPadding={true}>
                        <div className="gd-field-date view disabled m-l-5 m-t-5">
                            <SelectUser className="u-name"
                                        value={gd.session.me.id}
                                        options={options}
                                        renderValue="icon-name"
                                        underlined="on-hover"
                                        disabled={true}
                                        placeholder="No user"
                                        canHaveNoValue={true}
                                        noValueValue={null}
                                        noValueLabel="No user"/>
                        </div>
                    </CustomFieldPreview>
                </CustomFieldLeftPanel>

                <CustomFieldRightPanel parent={this}/>
            </React.Fragment>
        )
    }
}